import de from '@/resources/lang/de.js';
import en from '@/resources/lang/en.js';

export default defineI18nConfig(() => ({
  legacy: false,
  allowComposition: true,
  locales: ['de', 'en'],
  locale: 'de',
  messages: {
    de,
    en
  },
  lazy: true,
  langDir: 'resources/lang',
  numberFormats: {
    de: {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol'
      },
      currencyNoCents: {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0, // set fraction digits to 0 to remove cents
        maximumFractionDigits: 0
      }
    },
    en: {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol'
      }
    }
  }
}));
